import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import UpdateMediaUI from './updatemediaui';

export default class UpdateMedia extends Plugin {
  static get requires() {
    return [ UpdateMediaUI ];
  }

  static get pluginName() {
    return 'UpdateMedia';
  }
}
